module.exports = __webpack_public_path__ + "static/media/jzcard.81965c0e.png";